import PestPillarLayout from "./PestPillarLayout";

const PROBLEMS = [
  {
    title: "Rats (surmulots et rats noirs)",
    desc: "Présents dans les caves, granges, poulaillers et réseaux d'évacuation. Ils creusent des terriers, rongent les matériaux et se reproduisent rapidement si rien n'est fait.",
  },
  {
    title: "Souris et mulots",
    desc: "Fréquents dans les combles, les cloisons et les placards de cuisine. Leur petite taille leur permet de passer par des ouvertures d'à peine un centimètre.",
  },
  {
    title: "Prévention durable",
    desc: "Rebouchage des passages, conseils de stockage des aliments et des déchets, entretien des abords : les gestes qui limitent le risque d'une nouvelle infestation.",
  },
];

const METHOD = [
  { title: "Diagnostic sur place", desc: "Recherche des traces (crottes, passages, nids, dégâts), identification de l'espèce et repérage des points d'entrée du bâtiment." },
  { title: "Plan d'action et devis", desc: "Nous vous expliquons la méthode retenue, le nombre de passages prévus et les précautions à prendre. Devis gratuit, sans engagement." },
  { title: "Piégeage sécurisé", desc: "Pose de pièges mécaniques et de postes d'appâtage verrouillés, hors de portée des enfants et des animaux domestiques, aux endroits stratégiques." },
  { title: "Suivi et prévention", desc: "Contrôle des postes, retrait des rongeurs capturés, puis recommandations concrètes pour fermer les accès et éviter leur retour." },
];

const FAQ = [
  {
    q: "Combien de passages faut-il pour une dératisation ?",
    a: "Cela dépend de l'ampleur de l'infestation et de la configuration du bâtiment. Une intervention comprend généralement une pose initiale puis un ou plusieurs passages de contrôle. Le nombre exact vous est indiqué dans le devis, après le diagnostic.",
  },
  {
    q: "Les produits sont-ils dangereux pour mes animaux ?",
    a: "Nous utilisons uniquement des produits homologués, placés dans des postes d'appâtage sécurisés et verrouillés. Lorsque la présence d'animaux ou d'enfants l'impose, nous privilégions le piégeage mécanique. Les consignes de sécurité vous sont expliquées avant chaque pose.",
  },
  {
    q: "Faut-il quitter le logement pendant l'intervention ?",
    a: "Non, une dératisation ne nécessite pas de quitter votre domicile. Le technicien intervient en votre présence et vous montre l'emplacement de chaque piège ou poste installé.",
  },
  {
    q: "Comment éviter que les rongeurs reviennent ?",
    a: "Il faut supprimer ce qui les attire et leurs accès : reboucher les trous autour des canalisations, stocker aliments et graines dans des contenants fermés, gérer les déchets et le compost, entretenir les abords. Nous vous remettons des conseils adaptés à votre bâtiment.",
  },
];

const CITIES = ["Guéret", "La Souterraine", "Aubusson", "Bourganeuf", "Boussac", "La Celle-Dunoise"];

const RELATED = [
  { title: "Rats et souris à l'automne : signes d'infestation et prévention", slug: "rats-souris-automne-signes-infestation-prevention" },
  { title: "Dératisation en Creuse : quand faire appel à un professionnel ?", slug: "deratisation-creuse-quand-faire-appel-professionnel" },
];

export default function DeratisationCreusePage() {
  return (
    <PestPillarLayout
      slug="deratisation-creuse"
      seoTitle="Dératisation Creuse (23) — Rats et souris | K'REUSE"
      seoDescription="Dératisation en Creuse (23) : rats, souris, diagnostic, piégeage sécurisé et prévention. Technicien certifié Certibiocide. Devis gratuit."
      breadcrumbLabel="Dératisation Creuse"
      heroBadge="Rats · Souris · Certibiocide"
      heroTitleHtml={`Dératisation en <span class="font-medium text-[#1B5E20]">Creuse (23)</span>`}
      heroSubtitle="Rats, souris, mulots : nous identifions l'origine de l'infestation, mettons en place un piégeage adapté à votre logement et vous aidons à empêcher le retour des rongeurs."
      hero_h2="Rats et souris : agir vite, sans prendre de risques"
      introParagraphs={[
        "Bruits de grattement dans les combles, crottes le long des murs, emballages rongés, câbles abîmés : la présence de rongeurs se repère souvent par des indices discrets. En Creuse, maisons anciennes, granges, dépendances et caves offrent aux rats et aux souris des abris idéaux, surtout à l'arrivée de l'automne, lorsqu'ils cherchent chaleur et nourriture.",
        "Au-delà de la gêne, les rongeurs peuvent contaminer les denrées, dégrader l'isolation et les gaines électriques, et transmettre certaines maladies comme la leptospirose. Les produits vendus en grande surface, mal placés ou mal dosés, sont souvent peu efficaces et présentent des risques pour les enfants, les chiens, les chats et la faune sauvage.",
        "K'REUSE EXTÉRIEUR intervient avec un technicien certifié Certibiocide, l'agrément d'État obligatoire pour l'usage professionnel des produits biocides. Chaque intervention commence par un diagnostic : nous identifions l'espèce, évaluons l'ampleur de l'infestation et repérons les points d'entrée avant de vous proposer un devis clair.",
      ]}
      problems={PROBLEMS}
      method={METHOD}
      cities={CITIES}
      faq={FAQ}
      relatedArticles={RELATED}
      ctaTitle="Des rongeurs chez vous ? Parlons-en."
      whatsappText="Bonjour, je souhaite un devis pour une dératisation en Creuse."
      withQuoteForm
      quoteServiceIndex={7}
      quoteIntro="Traces de rongeurs, bruits dans les combles ? Décrivez-nous la situation : nous vous recontactons pour organiser le diagnostic et vous remettre un devis gratuit."
    />
  );
}
